<template>
  <v-dialog v-model="dialog" persistent max-width="290" :disabled="!confirm">
    <template v-slot:activator="{ on: dialog, attrs }">
      <v-tooltip :disabled="!tooltip" bottom transition="none" color="black">
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            :tile="tile"
            depressed
            :fab="fab"
            :color="color"
            :icon="icon && !text"
            :text="text && !icon"
            @click="$emit('clicked')"
            v-bind="attrs"
            v-on="{ ...tooltip, ...dialog }"
            :disabled="disabled"
          >
            <v-icon v-if="icon" :size="size">{{icon}}</v-icon>
            <slot v-else></slot>
          </v-btn>
        </template>
        <span>{{ tooltip }}</span>
      </v-tooltip>
    </template>
    <v-card>
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text>{{ subtitle }}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="onConfirm(false)">Cancel</v-btn>
        <v-btn :color="danger ? 'red' : 'green'" text @click="onConfirm(true)">Proceed</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "AxButton",
  props: {
    text: { type: Boolean, default: false },
    icon: { type: String, default: false },
    size: { type: String, default: 'lg' },
    color: { type: String, default: null },
    tooltip: { type: String, default: null },
    fab: { type: Boolean, default: false },
    tile: { type: Boolean, default: false },
    confirm: { type: Boolean, default: false },
    title: { type: String, default: 'Confirmation' },
    subtitle: { type: String, default: 'Are you sure you want to continue?' },
    danger: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return { 
      dialog: false,
    }
  },
  methods: {
    onConfirm(accept) {
      if (accept) {
        this.$emit('confirmed', true)
      }
      this.dialog = false 
    }
  }
}
</script>